import { css, Interpolation, Theme } from '@emotion/react'

export const tableContainer = (minWidth: number) => css`
  width: 100%;
  min-width: ${minWidth}px;
  overflow: hidden;
`

export const table: Interpolation<Theme> = css`
  width: calc(100% + 16px);
  border-spacing: 8px;
  margin: -8px;

  th,
  td {
    text-align: left;
    border: none;
  }
`

export const rowContainer: Interpolation<Theme> = css`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const fixedCell: Interpolation<Theme> = (theme) => css`
  background-color: ${theme.backgrounds.backgroundFive};
  font-weight: 500;
  color: ${theme.typographyColors.typographyTwo};
  box-shadow: ${theme.boxShadows.small};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: 14px;
  padding: 14px;
`

export const cellWithGap = (fieldCount: number) => css`
  &:nth-child(${fieldCount}n):not(:last-child) {
    padding-right: 16px;
  }
`

export const probingInputs: Interpolation<Theme> = css`
  display: flex;
  gap: 4px;

  > div {
    flex: 1;
  }
`

export const orthodonticSection: Interpolation<Theme> = css`
  margin-bottom: 24px;
`

export const orthodonticLabel: Interpolation<Theme> = css`
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
`

export const orthodonticInput: Interpolation<Theme> = css`
  width: 100%;
  max-width: 400px;

  .MuiOutlinedInput-root {
    height: 40px;
  }
`

export const groupContainer: Interpolation<Theme> = (theme) => css`
  margin-bottom: 24px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: 14px;
  padding: 16px;
`

export const groupTitle: Interpolation<Theme> = (theme) => css`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 12px;
`

export const groupWrapper: Interpolation<Theme> = css`
  margin-bottom: 24px;
`

export const rowTitle: Interpolation<Theme> = (theme) => css`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
  margin-bottom: 8px;
`

export const checkboxWrapper: Interpolation<Theme> = css`
  height: 48px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

// Lightweight native input styles for performance-critical tables
export const nativeInput: Interpolation<Theme> = (theme) => css`
  width: 100%;
  height: 48px;
  padding: 12px 14px;
  font-size: 16px;
  font-family: inherit;
  color: ${theme.typographyColors.typographyTwo};
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: 14px;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: ${theme.colors.blue};
  }

  &::placeholder {
    color: ${theme.typographyColors.typographyThree};
  }
`

// Native input wrapper with suffix (e.g., for degree symbol)
export const nativeInputWrapper: Interpolation<Theme> = css`
  position: relative;
  width: 100%;
`

export const nativeInputSuffix: Interpolation<Theme> = (theme) => css`
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: ${theme.typographyColors.typographyThree};
  pointer-events: none;
`

// Lightweight native checkbox styles for performance-critical tables
export const nativeCheckbox: Interpolation<Theme> = (theme) => css`
  appearance: none;
  width: 24px;
  height: 24px;
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 8px;
  cursor: pointer;
  position: relative;

  &:checked {
    border: 1px solid ${theme.colors.green};
    background: ${theme.colors.green};
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%) rotate(45deg);
    width: 5px;
    height: 10px;
    border: solid ${theme.colors.white};
    border-width: 0 2px 2px 0;
  }
`
